<!---底部-->
<template>
  <div
    class="overall-scene-box"
  >
    <div class="overall-scene">
      <a
        href="javascript:void(0);"
        class="overall-scene-change"
        v-stat:click="{ action: 'ZNCP-JH-m_click_109' }"
        v-stat:show="{ action: '3DZT-XCJ-m_show_1' }"
        v-show="!phoneCallStatus"
        @click="open3dLayer"
      >
        <p class="overall-scene-change-icon">
          <em></em>
        </p>
        <h3 class="overall-scene-change-text">3D场景</h3>
      </a>
      <ul
        class="overall-scene-list"
        ref="scene-list"
      >
        <template v-if="panoType === panoTypes.krpanpo">
          <li
            :ref="item.name"
            class="img-placeholder"
            :class="item.name === currentScene ? 'current' : ''"
            v-for="item in sceneList"
            :key="item.id"
            @click="switchScene(item.name)"
            v-stat:click="{ action: 'arhall_scenelist_click', extend: { channelId } }"
          >
            <em class="hasName"></em>
            <p>
              <span
                class="img"
                :style="{display:'block',background: 'url('+item.thumbUrl+')',backgroundSize:'cover' }"
                v-if="item.thumbUrl"
                :src="item.thumbUrl"
                :alt="item.title"
              />
            </p>
            <p
              class="overall-scene-name"
              v-if="item.seriesName && item.firstShowSpecId"
            >{{ item.seriesName }}</p>
          </li>
        </template>
        <template v-if="panoType === panoTypes.fourKankan">
          <li
            :ref="item.name"
            :class="item.name === currentScene ? 'current' : ''"
            class="img-placeholder"
            v-for="item in sceneList4d"
            :key="item.name"
            @click="switch4dScene(item)"
            v-stat:click="{  action: is360(item.imgType) ? 'ZNZT_2023chick_01': 'arhall_scenelist_click' }"
          >

             <em :class="{tag360:is360(item.imgType)}"></em>
            <p>
              <span
                class="img"
                :style="{display:'block', background: 'url('+item.url+')',backgroundSize:'cover' }"
                 v-if="item.url"
                :src="item.url"
                :alt="item.title"
              />
            </p>
            <p
              class="overall-scene-name"
              v-if="item.imgName"
            >{{ item.imgName }}</p>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import * as queryValue from '../services/query.const';
import layerManager from '../services/layer.manager';
import { staticIdProxy, actionProxy } from '../services/socketIO/user.action.interceptor';
import { ScrollSync } from '../services/socketIO/scroll';
import { SYNC_SCREEN } from '../services/eventBusType';
import panoTypes from '@/services/panoTypes';

export default {
  name: 'SceneList',
  inject: ['panoPromise'],
  data () {
    return {
      panoTypes,
      sceneBtn: { selected: true },
      kankanPano: null,
      sceneList4d: [{ url:'', title:'', panoId:0}],
      canFlyToPano: true, // 是否可以走位
      bottomCls: true,
    };
  },
  computed: {
    ...mapGetters({
      'sceneList': 'scene/sceneList',
      'currentScene': 'scene/currentScene',
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus',
      vrSalesInfo: 'sales/vrSalesInfo',
      rotateCarDataPanoIds: 'specDot/rotateCarDataPanoIds'
    }),
    is360 () {
      return (imgType) => {
       if (imgType===3) {
        return true;
       }
       return false;
      };
    },
    sceneCls () {
      if (this.sceneBtn.selected) {
        return 'slide-in';
      }
      return 'slide-out';
    },
    channelId () {
      return this.vrSalesInfo.channelId;
    },
    panoType () {
      const fdRight = this.baseInfo.fdRight;
      if (fdRight.hasRights && fdRight.hasPublish && fdRight.sceneId) {
        return panoTypes.fourKankan;
      }
      return panoTypes.krpanpo;
    }
  },
  created: staticIdProxy(function () {
    this.$bus.$on('icsToggleScene', () => {
      this.toggleScene();
    });
  }, 'scene-list'),
  mounted () {
    const self = this;
    this.$nextTick(()=>{
      let el = self.$refs['scene-list'];
      self.scrollSync = new ScrollSync('scene-list', el);
    });

    let sceneType = self.$queryParams.sceneType.toLowerCase();
    let hallType = self.$queryParams.hallType.toLowerCase();
    if (sceneType === queryValue.QUERY_SCENETYPE_3D || hallType === queryValue.QUERY_HALLTYPE_3D || (self.sceneList.length === 0 && self.panoType === panoTypes.krpanpo)) {
      layerManager.open3dLayer();
    }
    this.$bus.$on(SYNC_SCREEN, () => {
      this.toggelSceneCls(this.sceneBtn.selected);
    });
    this.panoPromise.then((panoInstance) => {
      panoInstance.on('scene_clicked', () => {
        this.toggleScene();
      });
      panoInstance.loadedPromise && panoInstance.loadedPromise.then(() => {
        self.kankanPano = panoInstance;
        self.getSceneList();
        self.watchFly();
      }).catch((r) => {
        console.log('errer=>', r);
      });
    });
  },
  methods: {
    ...mapMutations({
      'setCurrentScene': 'scene/setCurrentScene',
    }),
    /**
     * 4dkk-获取缩略图列表
     */
    getSceneList () {
      const imgTypeSortIdMap = new Map([
        [3, 3],
        [2, 1],
        [1, 2],
      ]);
      this.kankanPano.getTours && this.kankanPano.getTours().then((res) => {
        if (!res || !res.length) {
          this.sceneList4d = [];
          return;
        }
          const thumbsList = [];
          res.sort((a, b) => {
            // 按照类型排序 1. 主打车  2. 信息牌 3. 导览图
            // 1=信息展示牌，2=普通导览，3=主打车
            if (a.imgType !== b.imgType) {
              return (
                imgTypeSortIdMap.get(b.imgType) -
                imgTypeSortIdMap.get(a.imgType)
              );
            } else if (a.imgType === b.imgType && [1, 3].includes(a.imgType)) {
              return a.anchorId - b.anchorId;
            } else {
              return a.id - b.id;
            }
          });
          res.forEach((item) => {
            let itemInfo = JSON.parse(item.imgCoordinate);
            const thumbItem = {
              name: `sence_${item.id}`,
              panoId: itemInfo.panoId,
              target: itemInfo.target,
            };
            thumbItem.url = item.imgUrl;
            thumbItem.imgType = item.imgType;
            thumbItem.imgName = item.imgName;
            thumbsList.push(thumbItem);
          });
          this.sceneList4d = thumbsList;
          this.getStartPos();
        });
    },
    /**
     * 4dkk-获取初始点panoid定位初始缩略图
     */
    getStartPos () {
      if (!this.kankanPano.getPos) {
        return;
      }
      const pos = this.kankanPano.getPos();
      if (pos && pos.panoId) {
        this.setTargetScene(pos.panoId);
      }
    },
    /**
     * 4dkk-监听走位，根据走位设置缩略图选中状态
     */
    watchFly () {
      if (!this.kankanPano.kankan) { return; }
      this.kankanPano.kankan.Camera.on('flying.started', () => {
        this.canFlyToPano = false;
      });
      this.kankanPano.kankan.Camera.on('flying.ended', ({ targetPano }) => {
        this.canFlyToPano = true;
        if (!targetPano || !targetPano.id) {
          return;
        }
        this.setTargetScene(targetPano.id);
      });
    },
    /**
     * 4dkk-设置缩略图选中状态
     */
    setTargetScene (panoId) {
      const targetScenes = this.sceneList4d.filter(t => String(t.panoId) === panoId);
      if (targetScenes && targetScenes.length) {
        const targetScene = targetScenes[0];
        this.setCurrentScene(targetScene.name);
      } else {
        this.setCurrentScene('');
      }
    },
    toggleScene () {
      if (!this.changing) {
        this.changing = true;
        this.toggelSceneCls(!this.sceneBtn.selected);
        setTimeout(() => {
          this.changing = false;
        }, 420);
      }
    },
    toggelSceneCls: actionProxy('toggelSceneCls', function (selected) {
      this.sceneBtn.selected = selected;
    }),
    switchScene: actionProxy('switchScene', function (name) {
      if (this.currentScene === name) {
        return;
      }
      this.setCurrentScene(name);
      this.panoPromise.then((panoInstance) => {
        panoInstance.thumbnailClick(name);
      });
    }),
    /**
     * 4dkk-点击缩略图
     */
    switch4dScene (item) {
      if (!this.canFlyToPano) {
        return;
      }
      this.setCurrentScene(item.name);
      this.kankanPano.fly(item.panoId, item.target);
    },
    open3dLayer () {
      layerManager.open3dLayer();
    },
    /**
     * 缩略图滚动选中
     */
    sceneChange (newVal, sceneList) {
      if (!newVal || sceneList === 1) {
        return;
      }
      const index = sceneList.findIndex(o => o.name === newVal);
      if (index < 0 || isNaN(index)) {
        return;
      }
      let scencListDom = this.$refs['scene-list'];
      if (!scencListDom) {
        return;
      }
      if (!this.$refs[newVal] || this.$refs[newVal].length === 0) {
        return;
      }
      const parentWidth = scencListDom.clientWidth;
      let margin = 0;
      if(scencListDom.children.length>2) {
        margin = parseFloat(getComputedStyle(scencListDom.children[1],null).marginRight);
      }
      const width = this.$refs[newVal][0].clientWidth;
      const scrollLeft = scencListDom.scrollLeft;
      const maxScrollLeft = (width + margin) * (index + 1) - margin;
      const minScrollLeft = maxScrollLeft - width;
      this.scrollSync && this.scrollSync.disableScroll();
      if (scrollLeft + parentWidth < maxScrollLeft) {
        scencListDom.scrollLeft = maxScrollLeft - parentWidth;
      } else if (scrollLeft > minScrollLeft) {
        scencListDom.scrollLeft = minScrollLeft;
      }
      this.scrollSync && this.scrollSync.enableScroll();
    },
  },
  watch: {
    currentScene: {
      handler: function (newVal) {
        if (this.panoType === panoTypes.krpanpo) {
          this.sceneChange(newVal, this.sceneList);
        }
        if (this.panoType === panoTypes.fourKankan) {
          this.sceneChange(newVal, this.sceneList4d);
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/modules/SceneList.scss';
</style>
